<app-contact-info></app-contact-info>
<app-header></app-header>
<app-cart></app-cart>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-cookie-banner></app-cookie-banner>